// SSOT de tokens de tema (design system verix-erp).
//
// Fuente ÚNICA de verdad de la paleta neutra (light/dark), accents, densidades,
// radio y presets de tenant. Consumido por:
//   - src/index.css        → valores base estáticos (verificado por
//                             src/theme/__tests__/tokens.consistency.test.js)
//   - src/lib/buildThemeCss.js → override de tenant inyectado en runtime
//   - src/lib/themeDefaults.js  → re-exporta ACCENTS/DENSITIES/… (compat)
//
// Antes esta paleta vivía duplicada (index.css `.dark` + buildThemeCss
// `ATRIA_DARK`) y la densidad triplicada con valores divergentes. Si cambias un
// valor aquí, el test de consistencia obliga a alinear index.css.

/**
 * Paleta neutra por modo. Debe coincidir EXACTO con
 * los bloques `:root` (@layer base) y `.dark` de src/index.css.
 */
export const NEUTRAL = {
  light: {
    background: '0 0% 100%',
    foreground: '222 30% 13%',
    card: '0 0% 100%',
    cardForeground: '222 30% 13%',
    muted: '220 24% 94%',
    mutedForeground: '222 14% 44%',
    border: '222 22% 89%',
    input: '222 22% 89%',
    sidebarBackground: '220 28% 98%',
    sidebarForeground: '222 30% 13%',
    sidebarBorder: '222 22% 89%',
  },
  dark: {
    background: '222 28% 7%',
    foreground: '220 16% 92%',
    card: '221 22% 11%',
    cardForeground: '220 16% 92%',
    muted: '221 18% 15%',
    mutedForeground: '220 12% 62%',
    border: '222 16% 19%',
    input: '222 16% 19%',
    sidebarBackground: '222 28% 6%',
    sidebarForeground: '220 16% 92%',
    sidebarBorder: '222 16% 16%',
  },
};

/** Acentos de marca disponibles (hue/sat/lum del `--primary`). */
export const ACCENTS = {
  blue:     { h: 221, s: 78, l: 45, label: 'Azul' },
  teal:     { h: 184, s: 62, l: 38, label: 'Teal' },
  indigo:   { h: 244, s: 76, l: 56, label: 'Índigo' },
  emerald:  { h: 158, s: 64, l: 42, label: 'Esmeralda' },
  amber:    { h: 32,  s: 92, l: 52, label: 'Ámbar' },
  violet:   { h: 268, s: 70, l: 58, label: 'Violeta' },
  rose:     { h: 348, s: 78, l: 56, label: 'Rosa' },
  graphite: { h: 240, s: 6,  l: 22, label: 'Grafito' },
};

/**
 * Densidad — alineada con `html[data-density]` de index.css, que es la que gana
 * en runtime por especificidad. `rootPx` es el `font-size` raíz (escala las
 * utilidades Tailwind basadas en rem); `rowH/pad/gap` van a `--density-*`.
 */
export const DENSITIES = {
  compact:  { rowH: 32, pad: 8,  gap: 8,  fontBase: 13, rootPx: 14 },
  cozy:     { rowH: 40, pad: 12, gap: 12, fontBase: 14, rootPx: 16 },
  spacious: { rowH: 48, pad: 16, gap: 16, fontBase: 15, rootPx: 17 },
};

/** Radio por defecto (override de tenant vía BrandingTab). */
export const RADIUS_DEFAULT = '0.5rem';

// MODULE_KEYS espeja el Zod enum del backend (companyThemeSchema en
// backend/src/utils/schemas.ts). Si añades una key aquí, añádela allí también.
export const MODULE_KEYS = [
  'dashboard',
  'invoices', 'expenses', 'bank', 'taxes', 'accounting', 'fin_reports',
  'customers', 'pipeline', 'activities', 'sequences', 'segmentation',
  'projects_list', 'my_tasks', 'resources', 'profitability', 'inventory', 'suppliers',
  'my_zone', 'team', 'time', 'comp', 'lifecycle',
  'ai_assistant', 'automation', 'insights', 'ai_models', 'ai_history',
  'settings', 'roles', 'docs',
];

/** Tema de tenant por defecto — Atria · azul profundo · cozy. */
export const DEFAULT_TENANT_THEME = {
  primary: { h: 221, s: 78, l: 45 },
  accent:  'blue',
  density: 'cozy',
  surface: 'classic',
  radius:  RADIUS_DEFAULT,
  initial: 'V',
  modules: null,
  logo:    null,
};
